


export const DEFAULT_CONFIG = {
    header: {
        id: '1',
        organization_name: '', // Loaded from GeneralInfo sheet
        logo_url: '/images/mcJhajjar.png',
        contact_phone: '', // Loaded from GeneralInfo sheet
        contact_email: '', // Loaded from GeneralInfo sheet
        office_address: '' // Loaded from GeneralInfo sheet
    },
    footer: {
        id: '1',
        copyright_text: '© 2025 Municipal Council Jhajjar. All rights reserved.',
        quick_links: [
            { id: 'f1', label: 'Staff Attendance', path: '#', type: 'link' }
        ],
        social_links: [
            { platform: 'Twitter', url: '#', icon: 'Twitter' },
            { platform: 'Facebook', url: '#', icon: 'Facebook' },
            { platform: 'Instagram', url: '#', icon: 'Instagram' }
        ]
    },

    navigation: [
        { id: '2', label: 'Home', path: '/', sort_order: 2, type: 'link', parent_id: null, section: 'header' },
        { id: '3', label: 'Departments', path: '/departments', sort_order: 3, type: 'link', parent_id: null, section: 'header' },
        { id: '4', label: 'Online Services', path: '/services', sort_order: 4, type: 'link', parent_id: null, section: 'header' },
        { id: '5', label: 'Staff & Employees', path: '/staff', sort_order: 5, type: 'link', parent_id: null, section: 'header' },
        { id: '6', label: 'Acts & Rules', path: '/acts', sort_order: 6, type: 'link', parent_id: null, section: 'header' },
        { id: '7', label: 'News & Updates', path: '/news', sort_order: 7, type: 'link', parent_id: null, section: 'header' },
        { id: '8', label: 'Public Information', path: '/public-info', sort_order: 8, type: 'link', parent_id: null, section: 'header' },
        { id: '9', label: 'Tenders & Notices', path: '/news?category=Tender', sort_order: 9, type: 'link', parent_id: '7', section: 'header' },
        { id: '10', label: 'Contact Us', path: '/location', sort_order: 10, type: 'link', parent_id: null, section: 'header' },
        { id: '14', label: 'Grievance Redressal', path: '/grievance', sort_order: 14, type: 'link', parent_id: null, section: 'header' },

    ],
    unavailabilityReasons: {
        maintenance: { icon: "🔧", label: "Maintenance", message: "Maintenance", color: "yellow" }
    }
};

export const fetchAppConfig = async () => DEFAULT_CONFIG;
